import { TourTag } from './tour-tags';

export const TourTagLabel: { [tag in TourTag]: string } = {
    copenhagen: $localize`Copenhagen`,
    zealand: $localize`Zealand`,
    odense: $localize`Odense`,
    sonderjylland: $localize`South- & Southern Jutland`,
    himmerland: $localize`Himmerland`,
    nordjylland: $localize`North Jutland`,
    linkoping: $localize`Linköping`,
    jonkoping: $localize`Jönköping`,
    food_drinks: $localize`Food & drinks`,
    news: $localize`News`,
    original: $localize`StoryHunt Originals`,
    history: $localize`History`,
    nature: $localize`Nature`,
    art: $localize`Art`,
    urban: $localize`City exploring`,
    family: $localize`Family & children`,
    free: $localize`Free tours`,
    near: $localize`Close to me`,
    culture: $localize`Culture`,
    education: $localize`Educational`,
    cuisine: $localize`Cuisine`,
    local: $localize`Local life`,
    aalborg: $localize`Aalborg`,
    europe: $localize`Europe`,
    other: $localize`Other`
}

export const FancyTourTagLabel: { [tag in TourTag]?: string } = {
    europe: $localize`Top cities in Europe`
}
